import React from 'react'
import styled, {css} from 'styled-components'
import {getColor, media} from '@startlibs/utils'
import {Button, Icon} from '@startlibs/components'
import purviewLogo from '../../public/favicon.png'

const SignInPageWrapper = styled.div`
  min-height: 100%;
  @supports (flex-wrap: wrap) {
    display: flex;
    flex-direction: column;
  }
`

const SignInPageContent = styled.div`
  margin: auto;
  padding: 4rem 1rem 5rem;
  max-width: 46rem;
  width: 100%;
  .password-link {
    float: right;
    vertical-align: bottom;
    color: rgba(0,0,0,0.5);
    line-height: 19px;
    &.has-error {
      color: ${getColor('alert')};
    }
  }
`

const SystemLogo = styled.div`
  margin: 0 auto 3rem;
  text-align: center;
  div {
    position: relative;
    display: inline-block;
    :before {
      content: '';
      pointer-events: none;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.05);
    }
  }
  img {
    background: white;
    max-width: 320px;
    max-height: 180px;
    margin: 0 auto;
    ${media.max(400)`
      max-width: 240px;
    `}
  }
`

export const Card = styled.div`
  padding: 2.5rem;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  max-width: 40rem;
  margin: 0 auto;
  p {
    font-size: 14px;
  }
  ${props => props.centralizedContent && `
    text-align: center;
  `}
`
export const CardActionButton = styled(Button)`
  min-width: 12rem;
  margin: 2rem auto 0;
  display: block
`

export const CardHeader = styled.div`
  margin-bottom: 1.5rem;
  h1 {
    color: ${getColor('main')};
    font-size: 22px;
    margin-bottom: 0.75rem;
  }
  p {
    color: rgba(0,0,0,0.5);
    font-size: 14px;
  }
`
export const AdditionalInfo = styled.div`
  font-size: 12px;
  color: rgba(0,0,0,0.5);
`

export const AdditionalActionButtons = styled.div`
  padding-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const AdditionalActionText = styled.span`
  margin-right: 1rem;
  font-size: 13px;
  color: rgba(0,0,0,0.5);
`

export const FieldRequirements = styled.div`
  background: rgba(0,0,0,0.05);
  color: rgba(0,0,0,0.5);
  font-size: 11px;
  padding: 0.75rem;
  border-radius: 5px;
  ${props => props.hasErrors && css`
    background: #ffdedf;
    color: ${getColor('alert')};
  `}
`
export const BelowFieldDescription = styled.div`
  color: rgba(0,0,0,0.5);
  font-size: 11px;
  margin-bottom: 1rem;
  margin-top: -0.5rem;
`

export const SignInMessageBox = styled.div`
  padding: 1rem;
  border-radius: 5px;
  border: 1px solid ${props => props.warning ? '#b3880d' : getColor('main')};
  background: ${props => props.warning ? '#ffe18b' : '#bae5f7'};
  color: ${props => props.warning ? '#906c00' : 'inherit'};
  font-size: 14px;
  max-width: 35rem;
  margin: auto;
  margin-bottom: 1rem;
`
const PurviewMktMessage = styled. div `
  margin-top: 1.5rem;
//  font-size: 14px;
  color: rgba(0,0,0,0.5);
  text-align: center;
  a {
    color: ${getColor('main')};
    font-weight: 600;
  }
`
const PurviewFooterComponent = styled.div`
  color: rgba(0,0,0,0.4);
  padding: 0.5rem 1rem;
  background: rgba(0,0,0,0.1);
  margin: 2rem -2.5rem -2.5rem;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  font-size: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 50px;
    height: 50px;
    margin-right: 0.5rem;
  }
  .main-text {
    font-size: 13px;
    color: rgba(0,0,0,0.5);
    font-weight: 600;
    margin-bottom: 1px;
    display: inline-block;
    a {
      color: rgba(0,0,0,0.5);
      :hover {
        color: rgba(0,0,0,0.6);
      }
    }
  }
`
export const PurviewFooter = () => {
  return (
    <PurviewFooterComponent>
      <a href="https://www.purview.net/" target="_blank"><img src={purviewLogo} alt="Purview Logo"/></a>
      <div>
        <div className="main-text">Powered by <a href="https://www.purview.net/" target="_blank">Purview</a></div>
        <div>© {new Date().getFullYear()}. All Rights Reserved.</div>
      </div>
    </PurviewFooterComponent>
  )
}

export const SignInLayout = ({withoutFooter, className, children, providerInfo}) => {
  const logoURL = providerInfo.logoURL
  return (
    <SignInPageWrapper className={className}>
      <SignInPageContent>
        <SystemLogo><div><img src={logoURL} alt="Logo"/></div></SystemLogo>
        {children}
        {!withoutFooter && <PurviewMktMessage>Find this useful? Learn more at <a href="https://www.purview.net/" target="_blank">www.purview.net</a></PurviewMktMessage>}
      </SignInPageContent>
    </SignInPageWrapper>
  )
}
